import { ProjectTypeCodeType } from './project-type-code';

export interface ProjectType {
  projectTypeId: number;
  projectTypeCode: ProjectTypeCodeType;
}
